import { useRouter } from '@repo/ui/hooks/use-router';
import { lazy, Suspense, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { Alert, AlertDescription } from '@repo/ui/components/ui/alert';
import { readAiPrefill } from '@repo/ui/features/ai/assistant/ai-prefill';

const CreateInventaireWizard = lazy(() =>
  import('@repo/ui/features/inventaires/implentation/create-inventaire-wizard').then((mod) => ({
    default: mod.CreateInventaireWizard,
  })),
);

export default function InventaireCreatePage() {
  const router = useRouter();
  const [searchParams] = useSearchParams();
  const aiId = searchParams.get('ai');
  // Fiche transmise par l'assistant IA (sessionStorage) ; lue une seule fois par identifiant.
  const aiPrefill = useMemo(() => readAiPrefill(aiId), [aiId]);

  const rawType = searchParams.get('type')?.toLowerCase();
  const inventaireType =
    aiPrefill ? aiPrefill.inventory_type :
    rawType === 'alignement' ? 'ALIGNEMENT' :
    rawType === 'epaysage'   ? 'EPAYSAGE'   :
    'ARBRE';

  return (
    <div className="w-full min-h-screen">
      {aiId && !aiPrefill && (
        <div className="mx-auto max-w-7xl px-4 pt-6">
          <Alert variant="destructive">
            <AlertDescription>
              La fiche proposée par l&apos;IA n&apos;est plus disponible (session expirée ou onglet fermé). Relancez l&apos;analyse depuis
              l&apos;assistant IA, ou saisissez l&apos;inventaire normalement ci-dessous.
            </AlertDescription>
          </Alert>
        </div>
      )}
      <Suspense fallback={<DendromapLoader message="Chargement du formulaire..." />}>
        <CreateInventaireWizard
          inventaireType={inventaireType}
          aiPrefill={aiPrefill}
          onCancel={() => router.push('/admin/inventaires')}
        />
      </Suspense>
    </div>
  );
}
